export const BEGIN_LOAD_CONFIGURATION = "BEGIN_LOAD_CONFIGURATION";
export const END_LOAD_CONFIGURATION_SUCCESS = "END_LOAD_CONFIGURATION_SUCCESS";
export const END_LOAD_CONFIGURATION_ERROR = "END_LOAD_CONFIGURATION_ERROR";

export interface Configuration {
    clientId?: string;
    authority?: string;
    isLoading: boolean;
    error: string | null;
    is64Bit: boolean;
    clientLanguage: string;
    showWelcomeMessage: boolean;
    welcomeMessage: string[];
    version: string;
    schema: string;
    maximumIdleTimeoutForLockoutInSeconds: number;
    maximumIdleTimeoutForTerminationInSeconds: number;
    enableEmbeddedPowerBi: boolean;
}

interface BeginLoadConfigurationAction {
    type: typeof BEGIN_LOAD_CONFIGURATION;
}

interface EndLoadConfigurationSuccessAction {
    type: typeof END_LOAD_CONFIGURATION_SUCCESS;
    configuration: Configuration;
}

interface EndLoadConfigurationErrorAction {
    type: typeof END_LOAD_CONFIGURATION_ERROR;
    error: string;
}

export type ConfigurationActionTypes =
    | BeginLoadConfigurationAction
    | EndLoadConfigurationSuccessAction
    | EndLoadConfigurationErrorAction;
